import { LatestStatement } from './latest-statement.component';

export { LatestStatement };
